import { gql } from '@apollo/client';

export const CLOSE_TRADE_MUTATION = gql`
  mutation CloseTrade($id: Int!) {
    p {
      closeTrade(id: $id) {
        success
        message {
          code
          message
        }
        content {
          id
          status
        }
      }
    }
  }
`;
